import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {UserDisplayComponent} from './user-display.component';

@NgModule({
  imports: UserDisplayModule.IMPORTS,
  declarations: UserDisplayModule.DECLARATIONS,
  exports: UserDisplayModule.DECLARATIONS
})
export class UserDisplayModule {
  public static readonly IMPORTS = [CommonModule];

  public static readonly DECLARATIONS = [UserDisplayComponent];
}
